<template>
	<div class="vue-select" :class="{ 'vue-select-disabled' : disabled  , 'vue-select-opened' : show_dropdown }">
		<div class="vue-select-input form-control form-control-select"  v-if="disabled">
			<template v-if="selected">
				<div class="vue-select-selected">
					<slot name="selected" v-bind="selected" >{{selected.name}}</slot>
				</div>
			</template>
			<template v-else>
				<div class="vue-select-placeholder">
					{{ placeholder }}
				</div>
			</template>
		</div>
		<div class="vue-select-input form-control form-control-select"  @click="showDropdown()" v-else>
			<template v-if="selected">
				<div class="vue-select-selected">
					<slot name="selected" v-bind="selected" >{{selected.name}}</slot>
				</div>
			</template>
			<template v-else>
				<div class="vue-select-placeholder">
					{{ placeholder }}
				</div>
			</template>
		</div>
		<transition name="fade" mode="out-in">
			<div class="dropdown-menu" ref="dropdown" v-clickaway="hideDropdown" v-if="show_dropdown"  :class="[setPosition,{ 'dropdown-menu-width-search' : search }]" :style="{ width : setWidth }" >
				<div class="dropdown-item-search" v-if="search">
					<input type="search" placeholder="Search ..." ref="searchInput" v-model="keyword" class="form-control">
				</div>
				<simplebar v-if="listOptions.length" class="dropdown-menu-list-items" :style="{ 'max-height' : setHeight }">
					<template v-if="listOptions.length">
						<div class="dropdown-item" v-for="(option, index) in listOptions" :key="`options_index_${index}`" @click.stop.prevent="select(option)">
							<slot name="option" v-bind="option" >{{option.name}}</slot>
						</div>
					</template>
					<template v-else>
						<div class="dropdown-item"  v-if="options.length">
							Search not found !
						</div>
						<div class="dropdown-item"  v-else>
							Data not found !
						</div>
					</template>
				</simplebar>
				<div v-else class="dropdown-menu-list-items" :style="{ 'max-height' : setHeight }">
					<div class="dropdown-item"  v-if="options.length">
						Search not found !
					</div>
					<div class="dropdown-item"  v-else>
						Data not found !
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
export default {
	name : 'VueSelect',
	props:{
		value :{
			type : [String , Number],
			required : true,
		},
		options : {
			type : Array,
			required : true,
		},
		right : {
			type : Boolean,
			default : false
		},
		width : {
			type : [Number , String],
			default : '100%'
		},
		maxHeight :{
			type : Number,
			default : 200,
		},
		placeholder :{
			type : String,
			default : 'Select option'
		},
		disabled:{
			type : Boolean,
			default : false
		},
		tracking :{
			type : String,
			default: 'id'
		},
		search :{
			type : Boolean,
			default : false,
		},
		searchBy :{
			type : String,
			default : 'name'
		},
		searchEmptyPlaceholder :{
			type : String,
			default : 'Search not found !'
		},
		emptyPlaceholder :{
			type : String,
			default : 'Data not found !'
		}
	},
	data(){
		return {
			keyword : '',
			show_dropdown: false,
		}
	},
	computed:{
		setWidth(){
			return typeof this.width == 'number' ? `${this.width}px` : this.width
		},
		setHeight(){
			return `${this.maxHeight}px`
		},
		setPosition(){
			return this.right ? 'dropdown-menu-right' : ''
		},
		selected(){
			return _.find(this.options , (el)=>{
				return el[this.tracking] == this.value
			})
		},
		listOptions(){
			var kewword = this.keyword.toLowerCase().trim()
			return this.options.filter((item)=>{
				if( item.hasOwnProperty(this.searchBy)){
					var name = item[this.searchBy].toLowerCase().trim()
					return name.indexOf(kewword) >= 0
				}
				return true
			})
		}
	},
	methods:{
		select( item ){
			if( this.disabled ) return
			this.$emit('input', item[this.tracking])
			this.$emit('on-change', item[this.tracking])
			this.hideDropdown()
		},
		onSelect(){

		},
		hideDropdown(){
			this.show_dropdown = false 
			$(this.$refs.dropdown).removeClass('show');
		},
		showDropdown(){
			this.show_dropdown = true
			this.$nextTick(()=>{
				if( this.search ){
					this.$refs.searchInput.focus()
				}
				this.setDropDirection()
			})
		},
		setDropDirection() {
			let canDropDown = this.canDropDown()
			$(this.$el).toggleClass('dropdown', canDropDown);
			$(this.$el).toggleClass('dropup', !canDropDown);
			$(this.$refs.dropdown).addClass('show');
		},
		canDropDown() {
			let windowHeight = window.innerHeight;
			let distanceFromWindowTop = $(this.$el).offset().top - $(document).scrollTop();
			let elementHeight = $(this.$el).height();
			let distanceFromBottom =  windowHeight - distanceFromWindowTop - elementHeight;
			let menuHeight = $(this.$refs.dropdown).height();
			return menuHeight < distanceFromBottom
		}
	},
	mounted(){

	}
}
</script>
<style lang="scss" scoped>
	.vue-select{
		user-select: none;
		position: relative;
		&-disabled{
			opacity: 0.5;
			pointer-events: none;
		}
		&-opened{
			.vue-select-input{
				border-color: $border-bold;
			}
		}
		&.is-invalid{
			.vue-select-input{
				border-color: $red;
				background-color: #fbeae5;
				&:focus {
					border-color: $danger;
				}
			}
		}
		&-input{

		}
		&-selected{
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		&-placeholder{
			width: 100%;
		}
		.dropdown-menu{
			padding: 5px 0;
			background: #fff;
			border: 1px solid #D4D4D4;
			box-sizing: border-box;
			box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.18);
			border-radius: 4px;
			overflow: hidden;
			opacity: 0;
			visibility: hidden;
			display: block;
			transition: none;
			&-list-items{
				overflow: hidden auto;
			}
			&.show{
				opacity: 1;
				visibility: visible;
			}
			.dropdown-item{
				display: flex;
				justify-content: flex-start;
				align-items: center;
				cursor: pointer;
				padding: 0 10px;
				min-height: 40px;
				background: transparent;
				font-size: 13px;
				> * {
					width: 100%;
				}
				&:hover{
					background: rgba(0,0,0,0.1)
				}
			}
			.dropdown-item-search{
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				.form-control{
					border-top-width: 0;
					border-left-width: 0;
					border-right-width: 0;
					border-radius: 0;
				}
			}
			&.dropdown-menu-width-search{
				padding-top: 33px;
			}
		}
	}
</style>